<template>
    <div class="wf-rangePicker">
        <div class="wf-rangePicker-item">
            <span class="wf-rangePicker-item-label">选择日期</span>

            <div class="wf-rangePicker-inputBox">
                <div class="wf-rangePicker-item-input" @click="handleShowStart">
                    <input v-model="value[0]" type="text" readonly placeholder="请选择">
                </div>

                <div class="wf-rangePicker-space">~</div>

                <div class="wf-rangePicker-item-input" @click="handleShowEnd">
                    <input v-model="value[1]" type="text" readonly placeholder="请选择">
                </div>

                <div class="wf-rangePicker-icon">
                    <img :class="`${isShowStart || isShowEnd ? 'wf-rangePicker-icon-up' : ''}`" src="../image/rangePicker/wap_open.png" alt="">
                </div>
            </div>
        </div>

        <Popup v-model="isShowStart" position="bottom">
            <DatePicker :max-date="maxStartDate" :min-date="minStartDate"  v-model="componentValue[0]" type="date" title="选择开始日期" @confirm="handleConfirm($event, 0,)"></DatePicker>
        </Popup>

        <Popup v-model="isShowEnd" position="bottom">
            <DatePicker :min-date="minEndDate" :max-date="maxEndDate"  v-model="componentValue[1]" type="date" title="选择结束日期" @confirm="handleConfirm($event, 1)"></DatePicker>
        </Popup>

    </div>
</template>

<script>
import DatePicker from 'vant/lib/datetime-picker';
import Popup from 'vant/lib/popup'
import 'vant/lib/datetime-picker/style';
import 'vant/lib/popup/style'
import moment from 'moment';
import { Message } from 'iview'

export default {
    components: {
        DatePicker,
        Popup
    },
    props: {
        value: {
            type: Array,
            default: () => {
                return []
            }
		},
		maxInterval: {
			type: Number,
			default: 0
		},
		maxEndDate: undefined,
		minStartDate: undefined
    },
    data() {
        return {
            isShowStart: false,
            isShowEnd: false,
            //componentValue: []
        }
    },
    computed: {
        componentValue() {
            return [new Date(this.value[0]), new Date(this.value[1])]
		},
		minEndDate() {
			return new Date(this.value[0])
		},
		maxStartDate() {
			return new Date(this.value[1])
		}
    },
    model: {
        event: 'change',
        prop: 'value'
    },
    methods: {
        // 处理点击开始日期
        handleShowStart() {
            this.isShowStart = true
        },

        // 处理点击结束日期
        handleShowEnd() {
            this.isShowEnd = true
        },

        // 处理日期改变
        handleConfirm(event, key) {
            const currValue = [...this.value], prevValue = [...this.value]
            currValue[key] = moment(event).format('YYYY-MM-DD')
            if (key === 0) {
                this.isShowStart = false
            } else {
                this.isShowEnd = false
			}
			const startDate = currValue[0], endDate = currValue[1]
			if (this.maxInterval > 0) {
				if (new Date(endDate).getTime() - new Date(startDate).getTime() > 86400000 * 14) {
					Message.error(`日期区间不能大于${this.maxInterval}天`)
					currValue[(key + 1) % 2] = null
					this.$emit('change', currValue)
					return
                }
			}
            this.$emit('change', currValue)
            this.$emit('confirm', {
                newDate: currValue,
                oldDate: prevValue,
                key
            })
        }
    },
}
</script>

<style lang="scss" scoped>
.wf-rangePicker {
    display: flex;
    flex-direction: row;
    .wf-rangePicker-item {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        .wf-rangePicker-item-label {
            width: 1.04rem;
            font-size: 0.26rem;
            color: #666;
        }
        .wf-rangePicker-inputBox {
            position: relative;
            display: flex;
            flex-direction: row;
            flex: 1;
            align-items: center;
            margin-left: 0.16rem;
            padding-right: 0.5rem;
            border: 0.02rem solid #e0e0e0;
        }
        .wf-rangePicker-space {
            font-size: 0.26rem;
            line-height: 0.24rem;
            transition: transform 0.15s;
        }
        .wf-rangePicker-space-open {
            transform: rotate(180deg);
        }
        .wf-rangePicker-item-input {
            height: 0.58rem;
            flex: 1;
            border-radius: 0.04rem;
            > input {
                display: block;
                width: 100%;
                height: 100%;
                padding: 0 0.17rem;
                border: none;
                outline: none;
                font-size: 0.26rem;
                text-align: center;
                color: #333;
            }
            input::-webkit-input-placeholder {
                color: #ccc;
            }
            input::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: #ccc;
            }
            input:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: #ccc;
            }
            input:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: #ccc;
            }
        }
        .wf-rangePicker-icon {
            position: absolute;
            right: 0.21rem;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 0.13rem;
            height: 0.08rem;
            > img {
                display: block;
                width: 0.13rem;
                height: 0.08rem;
                transition: transform 0.15s;
            }
            .wf-rangePicker-icon-up {
                transform: rotate(180deg);
            }
        }
    }
    .wf-rangePicker-item:nth-child(2) {
        margin-right: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/rangePicker/rangePicker.vue